// extracted by mini-css-extract-plugin
module.exports = {"tabs":"TaskViewTabs_tabs__fKFAr","toolbar":"TaskViewTabs_toolbar__GY5lK","tab":"TaskViewTabs_tab__egd40","tabContent":"TaskViewTabs_tabContent__jUD9C"};